{
	"failed": {
		"description": "Check your connection and try again.",
		"retry": "Try again",
		"title": "The link could not be opened"
	},
	"file": {
		"download": "Download",
		"download_failed": "Download failed",
		"download_pending": "Preparing the download…",
		"expires": "Expires on {{date}}",
		"link_expires": "The link expires on {{date}}",
		"refused": {
			"failed": "The file could not be reached. Try again.",
			"relocked": "The link closed again. Enter the password once more.",
			"throttled_one": "Too many requests. Try again in {{count}} minute.",
			"throttled_other": "Too many requests. Try again in {{count}} minutes.",
			"unavailable": "This file is no longer reachable through the link."
		},
		"shared_by": "Shared by {{name}}",
		"shared_with_you": "<sender>{{name}}</sender> shared a file with you"
	},
	"folder": {
		"contents": "Contents of {{name}}",
		"download_file": "Download {{name}}",
		"empty": "This folder is empty",
		"failed": {
			"description": "It may have been moved, or the connection dropped. Reload the page.",
			"title": "This folder could not be opened"
		},
		"items_one": "{{count}} item",
		"items_other": "{{count}} items",
		"load_more": "Show more",
		"loading": "Loading the folder…",
		"loading_more": "Loading…",
		"shared_by": "Shared by {{name}}"
	},
	"header": {
		"language": "Language"
	},
	"loading": "Loading the link…",
	"password": {
		"description": "Enter the password the person who shared the file gave you.",
		"label": "Password",
		"pending": "Checking…",
		"submit": "Open",
		"throttled_one": "Too many attempts. Try again in {{count}} minute.",
		"throttled_other": "Too many attempts. Try again in {{count}} minutes.",
		"title": "This link is password protected",
		"wrong": "The password is not correct."
	},
	"relock": {
		"description": "The link closes again after 10 minutes without activity. Enter the password again to carry on from here."
	},
	"throttled": {
		"description_one": "Too many requests have come from this network. Try again in {{count}} minute.",
		"description_other": "Too many requests have come from this network. Try again in {{count}} minutes.",
		"title": "Too many attempts"
	},
	"unavailable": {
		"description": "It may have expired or been revoked, or the address is incomplete. Ask whoever sent it to share it again.",
		"title": "This link is not available"
	},
	"upload": {
		"add": "Add files",
		"cancel": "Cancel sending {{name}}",
		"change_name": "Change",
		"empty": {
			"description": "Upload the requested documents securely. The files go straight to {{name}}.",
			"description_anonymous": "Upload the requested documents securely. The files go straight into the folder.",
			"title": "Drag the files to send here"
		},
		"requested_by": "Requested by {{name}}",
		"retry": "Send {{name}} again",
		"sender": {
			"hint": "They'll see it next to the files you send.",
			"label": "What's your name?",
			"placeholder": "Full name, or company",
			"submit": "Start",
			"title": "{{name}} is asking you for files",
			"title_anonymous": "You've been asked for files"
		},
		"sending_as": "Sending as {{name}}",
		"size": "{{sent}} of {{total}}",
		"status": {
			"cancelled": "Cancelled",
			"delivered": "Delivered",
			"failed": "Failed",
			"no_room": "The folder has no room for this file",
			"relocked": "The link locked itself. Enter the password to continue.",
			"sending": "Sending",
			"throttled": "Too many uploads right now, try again later",
			"too_large": "Too large for this link",
			"unavailable": "This link no longer takes files",
			"waiting": "Waiting"
		},
		"table": {
			"actions": "Actions",
			"label": "Files sent from this page",
			"name": "Name",
			"size": "Size",
			"status": "Status",
			"type": "Type"
		}
	}
}
